import { useTranslation } from '@/i18n';

import AmbaImage from '../global/AmbaImage';

export type BadgeItemProps = {
  image: string;
  description: string;
  earned?: boolean;
  extraClass?: string;
  name: string;
};

const BadgeItem = ({ image, description, earned, extraClass, name }: BadgeItemProps) => {
  const { t } = useTranslation('dashboard');

  return (
    <div
      className={`badgeContainer d-flex overflow-hidden ${extraClass}`}
      style={{
        filter: earned ? '' : 'grayscale(100%)',
      }}
    >
      <div className="badgeLogoWrapper w-25">
        <AmbaImage alt={description} extraClass={`badgeLogo ${earned ? 'earned' : ''}`} imageSrc={image} isLink={false} />
      </div>
      <div className="badgeInfo w-75 pt-1 ms-1">
        <div className="badgeTitle f-raleway-regular f-12">
          <span>{name}</span>
        </div>
      </div>
    </div>
  );
};

export default BadgeItem;
